<mat-card class="iaq-comparison-card-container with-border">
  <div class="iaq-comparison-card-border"></div>
  <mat-card-title class="iaq-comparison-card-title">{{getComparison()}}x Healthier</mat-card-title>
  <mat-card-content>
    <p>Your building’s air is cleaner than outdoor air</p>
  </mat-card-content>
</mat-card>
